var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v("Connect Your Instagram Account")]),
    _vm._v(" "),
    _c("div", { staticClass: "ig-login-page" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("i", {
            staticStyle: {
              "background-image":
                "url('/static/img/instagram/instagram-login.png')",
              "background-position": "0px -502px",
              "background-size": "347px 606px",
              width: "175px",
              height: "51px",
              "background-repeat": "no-repeat",
              display: "inline-block",
            },
            attrs: { "data-visualcompletion": "css-img", role: "img" },
          }),
          _vm._v(" "),
          _c(
            "form",
            { staticClass: "form", attrs: { autocomplete: "chrome-off" } },
            [
              _c("a-input", {
                attrs: {
                  placeholder: "instagram username",
                  autocomplete: "chrome-off",
                  name: "ig-name",
                },
                model: {
                  value: _vm.auth.username,
                  callback: function ($$v) {
                    _vm.$set(_vm.auth, "username", $$v)
                  },
                  expression: "auth.username",
                },
              }),
              _vm._v(" "),
              _c("a-input-password", {
                attrs: {
                  placeholder: "instagram password",
                  autocomplete: "new-password",
                  name: "ig-password",
                },
                model: {
                  value: _vm.auth.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.auth, "password", $$v)
                  },
                  expression: "auth.password",
                },
              }),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.loading || _vm.isAuthenticating,
                  },
                  on: { click: _vm.saveAuthData },
                },
                [_vm._v("\n                    Log in\n                ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !(_vm.isAuthenticating || _vm.submitted) && _vm.isAuthError
            ? _c("a-alert", {
                staticClass: "mt-2",
                attrs: {
                  message: "Authentication Failed",
                  description:
                    "Please check your username and password and try again.",
                  type: "error",
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !(_vm.isAuthenticating || _vm.submitted) &&
          _vm.isAuthChallengeRequired
            ? _c("a-alert", {
                staticClass: "mt-2",
                attrs: {
                  message: "Authentication Failed - Challenge Required",
                  description:
                    "Please check your email and follow the instructions to complete the login process from your mobile device or desktop.",
                  type: "error",
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isAuthenticating || _vm.submitted
            ? _c(
                "a-alert",
                {
                  staticClass: "mt-2",
                  attrs: {
                    message: "Authenticating...",
                    type: "info",
                    "show-icon": "",
                  },
                },
                [
                  _c(
                    "p",
                    { attrs: { slot: "description" }, slot: "description" },
                    [
                      _c(
                        "a-spin",
                        { staticClass: "mr-2" },
                        [
                          _c("a-icon", {
                            staticStyle: { "font-size": "24px" },
                            attrs: {
                              slot: "indicator",
                              type: "loading",
                              spin: "",
                            },
                            slot: "indicator",
                          }),
                        ],
                        1
                      ),
                      _vm._v(
                        "\n                    Please wait while we authenticate your account.\n                "
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", {
        attrs: {
          src: "/static/img/instagram/login-left.png",
          width: "380",
          height: "580",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }